$(".flip-cards-row .flip-card-inner").click(function () {
  $(this).closest(".flip-card").toggleClass("is-flipped");
});

$(".speeding-flip-cards-row .flip-card-inner").click(function () {
  $(this).closest(".flip-card").toggleClass("is-flipped");
});
